var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.title ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
      _c("v-autocomplete", {
        attrs: {
          label: _vm.label,
          "item-text": "title",
          "item-value": "id",
          outlined: "",
          dense: _vm.dense,
          "hide-no-data": "",
          clearable: "",
          "auto-select-first": "",
          "hide-selected": false,
          items: _vm.placesFiltered,
          "search-input": _vm.searchPlace,
          "error-messages": _vm.errors,
          loading: _vm.$apollo.queries.places.loading || _vm.loading,
          disabled: _vm.loading,
        },
        on: {
          "update:searchInput": function ($event) {
            _vm.searchPlace = $event
          },
          "update:search-input": function ($event) {
            _vm.searchPlace = $event
          },
          input: function ($event) {
            return _vm.$emit("change", $event)
          },
        },
        model: {
          value: _vm.placeId,
          callback: function ($$v) {
            _vm.placeId = $$v
          },
          expression: "placeId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }